var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { staticClass: "bv-example-row" },
    [
      _vm.mensagem
        ? _c(
            "b-row",
            { attrs: { "align-h": _vm.getAlign } },
            [
              _c(
                "b-alert",
                {
                  staticClass: "alert-msg",
                  attrs: { variant: _vm.getVariant, show: "" }
                },
                [
                  _c(
                    "b-row",
                    { staticClass: "mb-2" },
                    [
                      _c("b-col", [
                        _c(
                          "small",
                          [
                            _c("b-avatar", {
                              attrs: {
                                variant: "light",
                                src: _vm.getPath,
                                size: "sm"
                              }
                            }),
                            _vm._v(" "),
                            _vm.mensagem.user_id !== parseInt(_vm.getUserId)
                              ? _c("b-badge", { attrs: { variant: "light" } }, [
                                  _vm._v(_vm._s(_vm.mensagem.user.name))
                                ])
                              : _c("b-badge", { attrs: { variant: "light" } }, [
                                  _vm._v("Você")
                                ])
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "text-right" },
                        [
                          _c(
                            "b-badge",
                            { attrs: { variant: "light" } },
                            [
                              _c("b-icon", { attrs: { icon: "clock" } }),
                              _vm._v(" "),
                              _c("small", [
                                _vm._v(" " + _vm._s(_vm.dateFormatted))
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.mensagem.mensagem
                    ? _c("b-row", { staticClass: "mt-2" }, [
                        _c("p", [_vm._v(_vm._s(_vm.mensagem.mensagem))])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.mensagem.arquivos && _vm.mensagem.arquivos.length > 0
                    ? _c(
                        "b-row",
                        { staticClass: "mt-2" },
                        _vm._l(_vm.mensagem.arquivos, function(arquivo, index) {
                          return _c("b-col", { key: index }, [
                            _c(
                              "a",
                              {
                                attrs: { href: "#" },
                                on: {
                                  click: function($event) {
                                    return _vm.visualizar(arquivo)
                                  }
                                }
                              },
                              [
                                _vm.getTipo(arquivo.tipo) == "image"
                                  ? _c(
                                      "b-img",
                                      _vm._b(
                                        {
                                          attrs: {
                                            src: arquivo.url,
                                            fluid: "",
                                            thumbnail: "",
                                            rounded: "",
                                            alt: "Rounded image"
                                          }
                                        },
                                        "b-img",
                                        _vm.mainProps,
                                        false
                                      )
                                    )
                                  : _c("i", {
                                      staticClass: "fas fa-file-pdf fa-lg"
                                    })
                              ],
                              1
                            )
                          ])
                        }),
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { "hide-footer": "", size: "xl" },
          model: {
            value: _vm.modalImagem,
            callback: function($$v) {
              _vm.modalImagem = $$v
            },
            expression: "modalImagem"
          }
        },
        [
          _vm.anexoSelecionado
            ? _c("b-img", {
                attrs: { fluid: "", src: _vm.anexoSelecionado.url }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-34b9b8a1", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34b9b8a1","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/atendimento/Mensagens.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-34b9b8a1","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/atendimento/Mensagens.vue
// module chunks = 2